import React from "react";
import Link from "gatsby-link";
import "./header.scss";
import Logo from "../../assets/logo.png";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  toggleNav = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  getMenuButtonAccessibleTitle = () =>
    this.state.isOpen ? "close menu" : "open menu";
  getMenuButtonTitle = () => (this.state.isOpen ? "×" : "☰");

  render() {
    const navClass = this.state.isOpen ? "nav--is-open" : "";
    return (
      <header className={"header"}>
        <nav className={`nav ${navClass}`}>
          <div className={"nav__wrapper nav__wrapper--main"}>
            <div className="nav__jump" />
            <Link className={"nav__title"} to="/">
              <img src={Logo} className={"nav__logo"} />
            </Link>
            <button
              aria-label={this.getMenuButtonAccessibleTitle()}
              className={"nav__button"}
              onClick={this.toggleNav}
            >
              {this.getMenuButtonTitle()}
            </button>
          </div>
          <div className={"nav__wrapper nav__wrapper--second"}>
            <Link className={"nav__item nav__item--film"} to="/">
              <span className={"nav__item__copy"} onClick={this.toggleNav}>Films</span>
            </Link>
            <Link to="/images/" className={"nav__item nav__item--images"}>
              <span className={"nav__item__copy"} onClick={this.toggleNav}>Snaps</span>
            </Link>
            <Link className={"nav__item nav__item--contact"} to="/contact/">
              <span className={"nav__item__copy"} onClick={this.toggleNav}>Reach</span>
            </Link>
            {this.props.audioIsPlaying ? (
              <button
                className={"nav__item nav__item--button nav__item--mute"}
                onClick={() => this.props.onPauseAudio(true)}
              >
                <span className={"nav__item__copy"}>Mute Audio</span>
              </button>
            ) : (
              <button
                className={"nav__item nav__item--button nav__item--unmute"}
                onClick={() => this.props.onPlayAudio(true)}
              >
                <span className={"nav__item__copy"}>Play Audio</span>
              </button>
            )}
          </div>
        </nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js